export default __webpack_public_path__ + "static/media/ico-notVer.52be3ad4.png";